'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".ItemTile-module_container__Qcwdg{padding:0 1px 1rem 0}.ItemTile-module_container__Qcwdg+.ItemTile-module_container__Qcwdg{padding:1rem 1px}.ItemTile-module_textContainer__vchL3{display:inline-block;padding-left:0;width:calc(100% - 1.5rem)}.ItemTile-module_textContainerWithImage__Sq4so{display:inline-block;padding-left:1.5rem;width:calc(100% - 7rem)}";
var styles = {"container":"ItemTile-module_container__Qcwdg","textContainer":"ItemTile-module_textContainer__vchL3","textContainerWithImage":"ItemTile-module_textContainerWithImage__Sq4so"};
styleInject["default"](css_248z, 'd7b07ac3-37bc-4789-82fe-da4828ca145c');

exports["default"] = styles;
